import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import questionIcon from "../../../assets/svgs/question.svg";
import rankIcon from "../../../assets/svgs/rank.svg";
import courseIcon from "../../../assets/svgs/course.svg";
import settingIcon from "../../../assets/svgs/setting.svg";
import arrowSvg from "../../../assets/svgs/arrow.svg";
import backgroundSvg from "../../../assets/svgs/BgAzvasa.svg";
import { ButtonYellow } from "../../../components/buttons";
import { useStudy } from "../hooks";
import { useCourse } from "../../course/hooks";
import { CourseComplete } from "../../../components/study/course";

const useStyles = makeStyles()((theme) => ({
  root: {
    minHeight: "calc(100vh - 96px)",
    background: "#f0f8ff",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  decorativeCircle1: {
    position: "absolute",
    top: -100,
    left: -100,
    width: 200,
    height: 200,
    borderRadius: "50%",
    background: "radial-gradient(circle, #ff9a9e 0%, #fad0c4 100%)",
  },
  decorativeCircle2: {
    position: "absolute",
    bottom: -50,
    right: -50,
    width: 150,
    height: 150,
    borderRadius: "50%",
    background: "radial-gradient(circle, #a1c4fd 0%, #c2e9fb 100%)",
    zIndex: 1,
  },
  bgImage: {
    position: "absolute",
    minHeight: "600px",
    height: "100%",
    bottom: "-50px",
    // right: '-20px',
    width: "100%",
    zIndex: 0,
  },
  container: {
    py: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    height: "calc(100vh - 96px)",
  },
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    color: "#4a4a4a",
    textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
  },
  subtitle: {
    color: "#5a5a5a",
  },
  gridContainer: {
    display: "grid",
    // gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(4),
    width: "100%",
  },
  button: {
    fontSize: "1.2rem",
    padding: "12px 24px",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 8px rgba(0,0,0,0.15)",
    },
  },
  infoItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    borderRadius: "15px",
    padding: "20px",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 6px 8px rgba(0,0,0,0.15)",
    },
  },
  iconWrapper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  infoTitle: {
    marginBottom: theme.spacing(1),
    color: "#4a4a4a",
    fontWeight: 500,
  },
  infoContent: {
    color: "#5a5a5a",
    textAlign: "center",
  },

  //new ui ---
  welcomeBox: {
    background: "#29ABE233",
    minHeight: "85dvh",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },
  welcomeContentBox: {
    // backgroundImage: `url(${backgroundSvg})`,
    // backgroundSize: 'center',
    // backgroundPosition: 'center center',
    // backgroundRepeat: 'no-repeat',
    width: "100%",
    height: "calc(100vh - 100px)",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundImage: `url(${backgroundSvg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      opacity: "25%",
      // filter: 'blur(10px) brightness(70%)', // Blur and dim effect
      zIndex: 0,
    },
  },
  welcomeGrid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1,
  },
  welcomeText: {
    color: "#FF716F",
    zIndex: 1,
    fontWeight: 700,
    fontFamily: '"milkshake", "Quicksand", cursive',
    textShadow: `-1px -1px 0 white,
                                1px -1px 0 white,
                                -1px 1px 0 white,
                                1px 1px 0 white,
                                -2px -2px 0 white,
                                2px -2px 0 white,
                                -2px 2px 0 white,
                                2px 2px 0 white,
                                -3px -3px 0 white,
                                3px -3px 0 white,
                                -3px 3px 0 white,
                                3px 3px 0 white,
                                -4px -4px 0 white,
                                4px -4px 0 white,
                                -4px 4px 0 white,
                        4px 4px 0 white`,
  },
  studentText: {
    zIndex: 1,
    color: "#2D9CDB",
    fontWeight: 700,
    fontFamily: '"Quicksand", sans-serif',
    textShadow: `
                                -2px -2px 0 white,
                                2px -2px 0 white,
                                -2px 2px 0 white,
                                2px 2px 0 white
                            `,
  },
}));

export const CourseWelcome = ({
  student,
  setSelectedCourse,
  courseId,
  activities,
  summaries,
  gate,
}) => {
  const { profile } = useStudy();
  const { classes } = useStyles();
  const [isHovered, setIsHovered] = useState(false);
  const {
    loadCurrent,
    current,
    lessonPlan,
    loadNextCourse,
    nextCourse,
    setAllCourseComplete,
    allCourseComplete,
    setCurrentCourseCompleted,
    currentCourseComplete,
  } = useCourse();

  useEffect(() => {
    if (courseId) {
      loadCurrent({ id: courseId });
      loadNextCourse({
        level: profile.gradeLevel,
        studentId: profile.id,
        courseId: courseId,
      });
    }
  }, [courseId]);

  useEffect(() => {
    // Course completion at login is decided by the SESSION GATE — a course
    // is complete only when every session passed. The old heuristic here
    // (any activity row on a chapter = chapter completed) falsely showed
    // legacy pre-gate users the completion screen: their old activity rows
    // touched every chapter without passing every session.
    if (!gate || !gate.eligible) return;

    // `/next-ir-level` resolves asynchronously (see onGetNextCourse saga).
    // Until it does, nextCourse is the initial/cleared {} which has no
    // nextLevel — deciding now would wrongly latch allCourseComplete=true
    // even when the student has a next level waiting, and that flag has no
    // reset path so the "all courses completed" screen would stick. Wait
    // for the response first. The backend always returns a populated
    // object, so a non-empty nextCourse means it has loaded (a genuine
    // end-of-all-levels response still has keys, with nextLevel === null).
    const nextCourseLoaded = nextCourse && Object.keys(nextCourse).length > 0;
    if (!nextCourseLoaded) return;

    if (!nextCourse.nextLevel) {
      setAllCourseComplete(true);
    } else if (!currentCourseComplete) {
      setCurrentCourseCompleted(true);
    }
  }, [gate, nextCourse, currentCourseComplete]);

  const onClickContinue = () => {
    setSelectedCourse(true);
  };

  return (
    <>
      {allCourseComplete ? (
        <CourseComplete  course={current} />
      ) : (
        <Box className={classes.welcomeBox}>
          <Box className={classes.welcomeContentBox}>
            <Grid container sx={{ mt: 8 }}>
              <Grid className={classes.welcomeGrid} item xs={12}>
                <Typography
                  className={classes.welcomeText}
                  sx={{
                    fontSize: {
                      xs: "2.3em",
                      sm: "2.4em",
                      md: "2.8em",
                      lg: "3.8em",
                      xl: "4.8em",
                    },
                  }}
                >
                  Welcome
                </Typography>
              </Grid>
              <Grid className={classes.welcomeGrid} item xs={12}>
                <Typography
                  className={classes.studentText}
                  sx={{
                    fontSize: {
                      xs: "1em",
                      sm: "1em",
                      md: "1.3em",
                      lg: "1.8em",
                      xl: "2.3em",
                    },
                  }}
                >
                  {student.firstName} {student.lastName}!
                </Typography>
              </Grid>
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                item
                xs={12}
              >
                <Typography
                  sx={{
                    color: "#000",
                    fontWeight: 700,
                    fontSize: { xs: "0.8em", md: "1.2em", lg: "1.4em" },
                    fontFamily: '"Quicksand", sans-serif',
                    zIndex: 1,
                  }}
                >
                  Here is your assigned course!
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Box
                  sx={{
                    position: "relative",
                    display: { xs: "block", sm: "flex" },
                    justifyContent: "space-between",
                    textAlign: "center",
                    background: "#fff",
                    p: 2,
                    mt: 2,
                    borderRadius: 2,
                    boxShadow: 10,
                    alignItems: "center",
                    borderTop: "2px solid #FF716F",
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <Box
                    sx={{
                      overflow: "hidden",
                      borderRadius: 2,
                      "& img": {},
                      "& img": {
                        transition: isHovered
                          ? "transform 0.3s ease-in-out"
                          : "",
                        transform: isHovered ? "scale(1.1) rotate(3deg)" : "", // Slight zoom-in and rotation
                      },
                      cursor: "pointer",
                    }}
                  >
                    <img
                      style={{ borderRadius: 10 }}
                      height={"150"}
                      src={current?.imageUrl}
                      alt=""
                    />
                  </Box>
                  <Box sx={{ p: 3, position: "relative" }}>
                    {/* <Typography sx={{
                                            fontSize: { xs: '0.8em', lg: '0.9em', xl: '1.2em' }, fontFamily: '"Quicksand", sans-serif', color: '#000',
                                            fontWeight: 600,
                                        }}>
                                            Level Assigned
                                        </Typography>
                                        <Typography sx={{
                                            fontSize: { xs: '1.5em', lg: '1.6em', xl: '1.9em' }, fontFamily: '"Quicksand", sans-serif', color: '#000',
                                            fontWeight: 700,
                                        }}>
                                            {profile?.gradeLevel || 'L7'}
                                        </Typography> */}
                    <Typography
                      sx={{
                        fontSize: { xs: "0.8em", lg: "0.9em", xl: "1.2em" },
                        fontFamily: '"Quicksand", sans-serif',
                        color: "#000",
                        fontWeight: 600,
                      }}
                    >
                      Course Assigned
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: "1.5em", lg: "1.6em", xl: "1.9em" },
                        fontFamily: '"Quicksand", sans-serif',
                        color: "#000",
                        fontWeight: 700,
                      }}
                    >
                      {current?.courseName}
                    </Typography>
                  </Box>
                  <ButtonYellow
                    sx={{
                      left: "50%",
                      transform: "translateX(-50%)",
                      position: "absolute",
                      bottom: "-30px",
                      mt: 2,
                    }}
                    onClick={onClickContinue}
                  >
                    <Typography
                      sx={{
                        fontWeight: "700",
                        fontFamily: '"Quicksand", sans-serif',
                        fontSize: {
                          xs: "1em",
                          md: "1.2em",
                          lg: "1.2em",
                          xl: "1.4em",
                        },
                        zIndex: 2,
                      }}
                    >
                      {activities?.length > 0 ? "Continue" : "Start"}
                    </Typography>
                    <img
                      style={{
                        width: "15%",
                        maxWidth: "100%",
                        marginTop: "5px",
                        height: "auto",
                        zIndex: 2,
                      }}
                      src={arrowSvg}
                      alt=""
                    />
                  </ButtonYellow>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
};
